define('controllers/mysetting/mod-userinfoper.ctrl',['app', 'mainCons'], function (app, mainCons) {
    app.controller('ModUserInfoPer', ['$q', '$scope', '$state', '$filter', 'auiUpload', 'auiDialog', 'OpenApp', 'UserInfo',
        'regionService', 'modUserInfoService', 'formValidateService', 'OpenUp', 'auiAgreementHelper', 'modBussService', '$rootScope', 'userAuth','cloudAcademyService', 'langService','commonUtils',
        function ($q, $scope, $state, $filter, auiUpload, auiDialog, OpenApp, UserInfo,
                  regionService, modUserInfoService, formValidateService, OpenUp, auiAgreementHelper, modBussService, $rootScope, userAuth,cloudAcademyService, langService,commonUtils) {
            var Model = $scope.Model = {
                idCardPicFgWH: '',
                idCardPicBgWH: '',
                idCardPic3WH: ''
            };
            var userInfo = Model.userInfo = {
                perCtfFg: '',
                perCtfBg: '',
                perCtf3: ''
            };
            Model.isTipShow = false;
            Model.firstmessTip = '';
            Model.submbIsGray = true;
            Model.doSubmit = function () {
            };
            Model.isShowNameChangeDiv = false;
            Model.inputIsDisable = true;
            Model.isRadioSelected = false;
            Model.isShowChaicon = true;
            Model.isAudting = false;
            Model.isRadioDisable = false;
            Model.isShowphoneValid = false;
            Model.channelOtherCheck = false;
            Model.verifiedEmailSuccess = false;
            Model.verifiedPhoneSuccess = false;
            Model.channelsList = systemParaConf.authentication.channels;
            Model.channelsChecked = [];
            Model.remark4userinfo = '';
            Model.isShowEmailValid = false;
            Model.isShowPerCtf3 = true;

            Model.isShowCloudCademy = false;
            Model.userInfo.country = {
                'key': '',
                'value': ''
            };
            Model.mainUserID = AUI.HDGWCall.getUserInfoValue('teamid');
            Model.signedAgreeList = [];
            Model.notAltModDevName = false;
            Model.agreement={}
            Model.shareAgreementList=[];
            Model.showAgreeList=[];
            var frameAgreements = mainCons.agreementConstants.frameAgreements;

            $scope.photoUrl =  sysParamCfg.photoUrl;
            Model.valid = modUserInfoService.getPerValid();


            var oldUserInfo = {};
            var userInfoToString = '';

            Model.isEmailNeedCode = false;
            // 显示语种集合
            Model.notifyMsgLangList = sysParamCfg.displaylangCountries;

            // 是否维护通知消息语种
            Model.showMsgLang = sysParamCfg.displayMsgLangFlag;
            // 计录页面修改项的计数
            var changeNum = 1;


            //定义各输入框对应的素数（控制提交按钮是否展示）
            var primes = modUserInfoService.returnPrimes();

            //SRM PRM错误信息展示
            Model.isShowPrmSrmTip = false;
            Model.PrmSrmMsgTip = "";
            $scope.changeRealName = changeRealName;

            Model.greenSubmit =greenSubmit;
            Model.graySubmit =graySubmit;
            if($state.$current.name =="mysetting.modUserInfoPer") {
                $rootScope.checkState($state).then(function () {
                    auiAgreementHelper.getAllAgreementStatus(sysParamCfg.shareAgreements.agrTypes).then(function (querySignInfoList) {
                        angular.forEach(querySignInfoList.signInfoList,function (signInfo) {
                            if (signInfo.signStatus != 3){
                                Model.shareAgreement=signInfo;
                                Model.shareAgreementList.push(Model.shareAgreement);
                            }

                        });
                        angular.forEach(Model.shareAgreementList,function (data) {
                            angular.forEach(sysParamCfg.shareAgreement,function (item) {
                                if(data.agrType===item.agrType){
                                    Model.agreement=item;
                                    Model.showAgreeList.push(Model.agreement);
                                }
                            })
                        });
                        if(Model.showAgreeList && Model.showAgreeList.length>0){
                            Model.isShowShareAgreement=true;
                        }else{
                            Model.isShowShareAgreement=false;
                        }
                        init();
                    }).catch(function () {
                        init();
                    });
                });
            }
            
            function setIsShowCloudCademy(){
            	cloudAcademyService.queryLecturerInfo().then(function(resp){
            		if(resp.resultCode == 0 && resp.lectrueInfo && AUI.BaseJSUtil.contains([1,2,4,5,6], resp.lectrueInfo.auditState)){
            			Model.isShowCloudCademy = true;
            		}
            	});
            }
            function getExtAttr(name) {
                var defer = $q.defer();
                modUserInfoService.getExtAttr(name).then(function (flag) {
                    defer.resolve(flag);
                });
                return defer.promise;
            }

            function init() {
                Model.countrys = [{'key': '中国', 'value': '中国'}];
                modUserInfoService.isSupportDevName().then(function (data) {
                    Model.isSupportDevName = data;
                    if(Model.isSupportDevName){
                        //获取cp信息展示
                        getExtAttr('altDevName').then(function (flag) {
                            if(flag == 0 || flag == 'null'){
                                Model.notAltModDevName = true;
                            }
                        });
                        getExtAttr('devNameStatus').then(function (flag) {
                            if(flag == 0){
                                Model.isShowInvalid = true;
                            }
                        });
                    }
                });
                regionService.setProvince(function (data) {
                    Model.provinces = data;
                    //获取cp信息展示
                    UserInfo.userAcctInfoList().then(function () {
                        setUserInfo();
                    });
                    setIsShowCloudCademy();
                    Model.userInfo.country = Model.countrys[0];
                    commonUtils.picExtend("imges1","imges2","imges3");
                });
                UserInfo.getUserRouteInfo().then(function (data) {
                    if (data.roleList && angular.isArray(data.roleList)) {
                        var roleList = data.roleList;
                        //改成取消显示非联盟协议
                        if(AUI.BaseJSUtil.contains(roleList, sysParamCfg.roleType.SM)){
                            Model.signedAgreeList.push(frameAgreements[0]);
                        }
                        if (AUI.BaseJSUtil.contains(roleList, sysParamCfg.roleType.HWCloudRole)) {
                            Model.signedAgreeList.push(frameAgreements[5]);
                        }
                    }
                });

            }

            function validateData() {
                if (Model.isEmailNeedCode&& !Model.verifiedEmailSuccess) {
                    angular.element("[name='verifyEmailCode']").focus();
                    return false;
                }
                if (Model.isPhoneNeedCode && !Model.verifiedPhoneSuccess) {
                    angular.element("[name='verifyCode']").focus();
                    return false;
                }
                return true;
            }

            //跳转更名页面
            function changeRealName() {
                UserInfo.updateCache(function () {
                    $state.go("nameChangePer", {reload: true});
                });
            }

            //选择或或知渠道
            Model.selectChannel = function (value) {
                modUserInfoService.selectChannelType(value,Model,primes,differValue,sameValue,oldUserInfo);
            }

            Model.downLoadAgreement = function (row) {
                auiAgreementHelper.viewAndDownloadAgreements(mainCons.agreementConstants.frameAgreementTypes);
            };


            Model.uploadPerCtfBg = function (files, options) {
                upload2openUP(files, options, primes.idCardPicFgPrime, 'perCtfFg', 'idCardPicFgWH', 'perCtfFgValid');
            };

            Model.uploadPerCtfBgImg = function (files, options) {
                upload2openUP(files, options, primes.idCardPicBgPrime, 'perCtfBg', 'idCardPicBgWH', 'perCtfBgValid');
            };

            Model.uploadAppealAttach = function (files, options) {
                upload2openUP(files, options, primes.appealAttach, 'appealAttach', 'appealAttach');
            };

            Model.uploadPerCtf3Img = function (files, options) {
                upload2openUP(files, options, primes.idCarePic3Prime, 'perCtf3', 'idCardPic3WH', 'ctf3Valid');
            };
            Model.uploadPerCtfNcImg = function (files, options) {
                auiUpload.upload2openUP(files, '1', options).then(function (fileUrl) {
                    if (fileUrl) {
                        Model.userInfo.perCtfNc = fileUrl;
                        AUI.HTMLUtil.drawImage(180, 120, fileUrl, function (wh) {
                            $scope.$apply(function () {
                                Model.idNameChangeWH = wh;
                            });
                        });
                    }
                });
            };

            function upload2openUP(files, options, prime, img, imgHW, isValid) {
                auiUpload.upload2openUP(files, '1', options).then(function (fileUrl) {
                    if (fileUrl) {
                        differValue(prime);
                        if (isValid) {
                            Model.valid[isValid].isValidSuc = false;
                        }
                        Model.userInfo[img] = fileUrl;
                        AUI.HTMLUtil.drawImage(180, 120, fileUrl, function (wh) {
                            $scope.$apply(function () {
                                Model[imgHW] = wh;
                            });
                        });
                    } else {
                        sameValue(prime);
                    }
                });
            }

            Model.cancel = function () {
                $state.go('mysetting.modUserInfoPer', {refresh: true}, {reload: true});
            };
            Model.cancelSubmit = userAuth.cancelDeveloperUpdate;

            Model.realNameKeyup = function () {
                var prime = primes.realNamePrime;
                // 如果新值跟原值不一样，则亮化提交按钮，并计入changeNum
                if (oldUserInfo.perRealName != Model.userInfo.perRealName) {
                    Model.isShowNameChangeDiv = true;
                    differValue(prime);
                }
                else {
                    Model.isShowNameChangeDiv = false;
                    sameValue(prime);
                }
            };

            Model.devName4InnerKeyup = function () {
                checkPrimePer("devName4Inner","devName4InnerPrime");
            };

            Model.devNameEn4InnerKeyup = function () {
                checkPrimePer("devNameEn4Inner","devNameEn4InnerPrime");
            };

            Model.realNameEnKeyup = function () {
                checkPrimePer("realNameEn","realNameEnPrime");
            };

            Model.contactEmailKeyup = function () {
                var prime = primes.contactEmailPrime;
                // 如果新值跟原值不一样，则亮化提交按钮，并计入changeNum
                if (Model.userInfo.contactEmail != oldUserInfo.contactEmail) {
                    differValue(prime);
                }
                else {
                    sameValue(prime);
                }
                Model.isEmailNeedCode =(!UserInfo.checkIsSameWithUPEmail(Model.userInfo.contactEmail,Model.userInfo.accountEmail)
                && Model.userInfo.contactEmail !=oldUserInfo.contactEmail);
            };

            Model.contactPhoneKeyup = function () {
                var prime = primes.contactPhonePrime;
                // 如果新值跟原值不一样，则亮化提交按钮，并计入changeNum
                if (oldUserInfo.contactPhone != Model.userInfo.contactPhone){
                    differValue(prime);
                }
                else {
                    sameValue(prime);
                }
                Model.isPhoneNeedCode =(!UserInfo.checkIsSameWithUPPhone(Model.userInfo.contactPhone,Model.userInfo.accountPhone)
                && Model.userInfo.contactPhone !=oldUserInfo.contactPhone)
            };

            Model.indivAddressKeyup = function () {
                var prime = primes.addressPrime;
                // 如果新值跟原值不一样，则亮化提交按钮，并计入changeNum
                if (oldUserInfo.indivAddress != Model.userInfo.indivAddress) {
                    differValue(prime);
                }
                else {
                    sameValue(prime);
                }
            };
            Model.reamrkKeyup = function () {
                var prime = primes.remark4userinfo;
                // 如果新值跟原值不一样，则亮化提交按钮，并计入changeNum
                if (oldUserInfo.remark4userinfo) {
                    if (oldUserInfo.remark4userinfo != Model.userInfo.remark4userinfo) {
                        differValue(prime);
                    }
                    else {
                        sameValue(prime);
                    }
                } else {
                    if (Model.userInfo.remark4userinfo) {
                        differValue(prime);
                    }
                    else {
                        sameValue(prime);
                    }
                }
            };
            Model.acceptEDMKeyup = function (acceptEDM) {
                if (Model.isAudting) return;
                Model.userInfo.acceptEDM = !acceptEDM;
                var prime = primes.acceptEDM;
                // 如果新值跟原值不一样，则亮化提交按钮，并计入changeNum
                if (oldUserInfo.acceptEDM != Model.userInfo.acceptEDM) {
                    differValue(prime);
                }
                else {
                    sameValue(prime);
                }
            };
            Model.learnchannelsOtherKeyup = function () {
                var prime = primes.learnchannelsOther;
                // 如果新值跟原值不一样，则亮化提交按钮，并计入changeNum
                if (oldUserInfo.learnchannelsOther) {
                    checkPrimePer("learnchannelsOther","learnchannelsOther");
                } else {
                    if (Model.userInfo.learnchannelsOther) {
                        differValue(prime);
                    }
                    else {
                        sameValue(prime);
                    }
                }
            };



            Model.perCtfCodeKeyup = function () {
                var prime = primes.idNumberPrime;
                // 如果新值跟原值不一样，则亮化提交按钮，并计入changeNum
                if (oldUserInfo.perCtfCode != Model.userInfo.perCtfCode) {
                    differValue(prime);
                }
                else {
                    sameValue(prime);
                }
            };

            Model.changeProvince = function (province) {

                // 城市目前需要通过接口获取到数据后进行映射
                regionService.setCity(province, function (data) {
                    Model.cities = data;
                    var prime = primes.provincePrime;
                    // 如果新值跟原值不一样，则亮化提交按钮，并计入changeNum
                    if (Model.userInfo.province && oldUserInfo.perProvince != Model.userInfo.province.value) {
                        Model.userInfo.city = Model.cities[0];
                        Model.userInfo.perProvince = Model.userInfo.province.value;
                        Model.userInfo.perCity = Model.userInfo.city.value;
                        differValue(prime);
                    }
                    else {
                        sameValue(prime);
                    }
                });
            };

            Model.changeCity = function () {
                var prime = primes.cityPrime;
                // 如果新值跟原值不一样，则亮化提交按钮，并计入changeNum
                if (Model.userInfo.city && oldUserInfo.perCity != Model.userInfo.city.key) {
                    Model.userInfo.perCity = Model.userInfo.city.key;
                    differValue(prime);
                }
                else {
                    sameValue(prime);
                }
            };

            Model.qqKeyup = function () {
                var prime = primes.qqPrime;
                // 如果新值跟原值不一样，则亮化提交按钮，并计入changeNum
                if (Model.userInfo.qq != oldUserInfo.qq) {
                    differValue(prime);
                }
                else {
                    sameValue(prime);
                }
            };

            // 输入控件值与原值一样，处理changeNum及提交按钮的样式
            function sameValue(prime) {
                // 跟原值一样，从changeNum清除本项计数
                changeNum =modUserInfoService.sameValue(prime,changeNum);
                // 如果计数已清空，则灰化提交按钮
                if (changeNum == 1) {
                    Model.graySubmit();
                }
            }

            // 输入控件值与原值不一样，处理changeNum及提交按钮的样式
            function differValue(prime) {
                changeNum =modUserInfoService.differValue(prime,changeNum);
                Model.greenSubmit();
            }

            // 提交按钮亮化
            function greenSubmit() {
                Model.submbIsGray = false;
                Model.doSubmit = doSummit;
            }

            //修改提交
            function doSummit(isValid,perUserForm) {
                if (changeNum > 1) {
                    if(perUserForm && perUserForm.perCtf3)perUserForm.perCtf3.$setDirty(true);
                    if(perUserForm && perUserForm.perCtfBg)perUserForm.perCtfBg.$setDirty(true);
                    if(perUserForm && perUserForm.perCtfFg)perUserForm.perCtfFg.$setDirty(true);
                    if (!isValid) {
                        formValidateService.validateForm(perUserForm);
                        validateData();
                    } else {
                        if (!validateData()) return;
                        //渠道不为为空
                        if (Model.channelsChecked.length == 0) {
                            Model.channelOtherCheck = true;
                            return;
                        } else {
                            Model.channelOtherCheck = false;
                        }
                        var params = getUpdateParam();
                        updateUserInfo(params);
                    }

                }
            }
            // 提交按钮灰化
            function graySubmit() {
                Model.submbIsGray = true;
                Model.doSubmit = function () {
                };
            }


            function checkPrimePer(key,primeName) {
                var prime = primes[primeName];
                // 如果新值跟原值不一样，则亮化提交按钮，并计入changeNum
                (oldUserInfo[key] != Model.userInfo[key])?differValue(prime):sameValue(prime);
            }

            function updateUserInfo(params) {
                Model.doSubmit = function () {};
                modUserInfoService.updateUserInfo(params).then(function (data) {
                    if (data && data.userID) {
                            auiDialog.success('资料提交成功。', function () {
                                Model.cancel();
                                $scope.$emit("stateChangedEvent", true);
                            });
                    }
                    else {
                        Model.resetVer =true;
                        Model.doSubmit = doSummit;
                    }
                });
            }

            // 组织更新接口调用的请求参数
            function getUpdateParam() {
                /*
                 * 组装developerInfo数据
                 */
                var devObj = {};
                devObj.country = 'CN';
                devObj.acceptEDM = Model.userInfo.acceptEDM ? 1 : 2;
                if (oldUserInfo.contactEmail != Model.userInfo.contactEmail) {
                    devObj.contactEmail = Model.userInfo.contactEmail;
                }
                if (oldUserInfo.contactPhone != Model.userInfo.contactPhone) {
                    devObj.contactPhone = "0086" + Model.userInfo.contactPhone.replace("+", "00");
                }
                if (oldUserInfo.qq != Model.userInfo.qq) {
                    devObj.contactQQ = Model.userInfo.qq;
                }
                if (oldUserInfo.realNameEn != Model.userInfo.realNameEn) {
                    // 隐藏数据提交
                    devObj.realNameEn = $.trim(Model.userInfo.realNameEn);
                }
                if(Model.isSupportDevName){
                    if (oldUserInfo.devName4Inner != Model.userInfo.devName4Inner) {
                        // 隐藏数据提交
                        devObj.devName4Inner = Model.userInfo.devName4Inner;
                    }
                    if (oldUserInfo.devNameEn4Inner != Model.userInfo.devNameEn4Inner) {
                        // 隐藏数据提交
                        devObj.devNameEn4Inner = Model.userInfo.devNameEn4Inner;
                    }
                }

                // 需要验证的手机号码提交验证码
                if (Model.isPhoneNeedCode) {
                    devObj.smsAuthCode = Model.userInfo.verCode;
                }
                // 需要验证的手机号码提交验证码
                if (Model.isEmailNeedCode) {
                    devObj.emailAuthCode = Model.userInfo.verEmailCode;
                }


                if(Model.needAppealAttach  && Model.userInfo.appealAttach){
                    devObj.appealAttach = Model.userInfo.appealAttach;
                }

                /*
                 * 组装indivDeveloper数据
                 */
                var perObj = {};


                if (oldUserInfo.perRealName != $.trim(Model.userInfo.perRealName)) {
                    perObj.realName = $.trim(Model.userInfo.perRealName);
                    // 隐藏数据提交
                    devObj.contactName = $.trim(Model.userInfo.perRealName);
                }
                if (oldUserInfo.perCtfCode != Model.userInfo.perCtfCode) {
                    perObj.ctfCode = Model.userInfo.perCtfCode;
                }
                if (oldUserInfo.perCtfBg != Model.userInfo.perCtfBg) {
                    perObj.attachment2 = Model.userInfo.perCtfBg ? Model.userInfo.perCtfBg : '';
                }
                if (oldUserInfo.perCtfFg != Model.userInfo.perCtfFg) {
                    perObj.attachment1 = Model.userInfo.perCtfFg ? Model.userInfo.perCtfFg : '';
                }
                if (oldUserInfo.perCtf3 != Model.userInfo.perCtf3) {
                    perObj.attachment3 = Model.userInfo.perCtf3 ? Model.userInfo.perCtf3 : '';
                }
                if (oldUserInfo.indivAddress != $.trim(Model.userInfo.indivAddress)) {
                    perObj.indivAddress = $.trim(Model.userInfo.indivAddress);
                }

                if (oldUserInfo.perProvinceName != Model.userInfo.province.key) {
                    perObj.provinceName = Model.userInfo.province.key;
                    devObj.province = Model.userInfo.province.key;
                }
                if (oldUserInfo.perCityName != Model.userInfo.city.key) {
                    perObj.cityName = Model.userInfo.city.key;
                    devObj.city = Model.userInfo.city.key;
                }
                modUserInfoService.setLearnchannels(oldUserInfo,Model,devObj);

                if (oldUserInfo.remark4userinfo != Model.userInfo.remark4userinfo) {
                    devObj.remark4userinfo = Model.userInfo.remark4userinfo;
                }

                if (oldUserInfo.msgLang != $.trim(Model.userInfo.msgLang)) {
                    // 通知消息语种
                    devObj.msgLang = Model.userInfo.msgLang;
                }


                // 组装最终的请求参数对象
                var params = {};
                if (!AUI.BaseJSUtil.isEmptyArray(devObj)) {
                    params.developerInfo = devObj;
                }
                if (!AUI.BaseJSUtil.isEmptyArray(perObj)) {
                    params.indivDeveloper = perObj;
                }

                return params;
            }

            function setUserInfo() {
                 UserInfo.getUserInfo().then(function (user) {
                     //开关开后优化吧  暂时查询1000
                     auiAgreementHelper.queryAgreements([systemParaConf.petalsAgreements.tremPdfConfType, systemParaConf.petalsAgreements.ServicePdfConfType]).then(function (res) {
                         if(user.verifyBankState == 2 && res.signInfoList &&res.signInfoList[0] && res.signInfoList[1] && (res.signInfoList[0].signStatus == 1 || res.signInfoList[0].signStatus == 2) && (res.signInfoList[1].signStatus == 1 || res.signInfoList[1].signStatus == 2) && (user.verifyType == 4 || user.verifyType == 2)){
                             Model.isCtfPic = true;
                         }
                         Model.userInfo = angular.copy(user);
                         Model.oldDevName4Inner = angular.copy(Model.userInfo.devName4Inner);
                         Model.oldDevNameEn4Inner = angular.copy(Model.userInfo.devNameEn4Inner);
                         Model.userInfo.perCtfCode = formValidateService.hiddenInfo(Model.userInfo.perCtfCode,3,4);



                         //如果用户类型是企业，则需要跳转到企业的信息设置页面
                         if (!AUI.HDGWCall.getUserInfoValue('teamid')) {
                             if (Model.userInfo.userType == 2) {
                                 if (Model.userInfo.verifyType == 3 && Model.userInfo.verifyRealState == 1) {
                                     $state.go('mysetting.validCorpattion', {reload: true});
                                     return;
                                 } else {
                                     $state.go('mysetting.modUserInfoCorp', {reload: true});
                                     return;
                                 }
                             }
                         } else {
                             $state.go('mysetting.memberDetail', {reload: true});
                             return;
                         }

                         userInfoToString = angular.toJson(angular.copy(Model.userInfo));
                         modUserInfoService.saveOldUserInfo(oldUserInfo, Model.userInfo);
                         //驳回情况
                         if (user.updateRealState == 3) {
                             if (Model.userInfo.approveOpinion == "102") {
                                 Model.isTipShow = true;
                                 Model.firstmessTip = "【系统消息】您提交的更名申请，由于银行信息审核不通过被驳回,请参照商户服务页面的审核意见修改后重新提交更名申请。";
                             }
                         }
                         // 省份目前需要通过接口获取到数据后进行映射
                         Model.userInfo.province = {
                             'key': Model.userInfo.perProvinceName,
                             'value': regionService.getProvinceFromList(Model.userInfo.perProvinceName, Model.provinces)
                         };

                         // 城市目前需要通过接口获取到数据后进行映射
                         regionService.setCity(Model.userInfo.perProvinceName, function (data) {
                             Model.cities = data;
                             Model.userInfo.city = {
                                 key: Model.userInfo.perCityName,
                                 value: regionService.getCityFromList(Model.userInfo.perCityName, Model.cities)
                             };
                         });

                         //获取获知渠道
                         if (Model.userInfo.learnchannels) {
                             Model.channelsChecked = Model.userInfo.learnchannels.split(';');
                             for (var ch = 0; ch < Model.channelsChecked.length; ch++) {
                                 Model.channelsChecked[ch] = parseInt(Model.channelsChecked[ch]);
                             }
                         }
                         //实名认证审核中   更名审核中
                         if (user.verifyRealState == 1 || user.updateRealState == 1 || user.isChangeRealName == 1) {
                             setReadOnly();
                             if (user.isChangeRealName == 1) {
                                 Model.isRadioSelected = true;
                                 Model.isShowNameChangeDiv = true;
                             } else {
                                 Model.isShowNameChangeDiv = false;
                             }
                             Model.isShowChaicon = false;

                         } else {
                             Model.isShowNameChangeDiv = false;
                             Model.isShowChaicon = true;
                             Model.userInfo.perCtfNc = '';
                         }


                         modUserInfoService.drawImage(Model,"perCtfFg","idCardPicFgWH",$scope);
                         modUserInfoService.drawImage(Model,"perCtf3","idCardPic3WH",$scope);
                         modUserInfoService.drawImage(Model,"perCtfBg","idCardPicBgWH",$scope);
                         modUserInfoService.drawImage(Model,"perCtfNc","idNameChangeWH",$scope);

                         //实名变更增加的选项配置 start
                         Model.updateRealState = user.updateRealState;
                         Model.verifyRealState = user.verifyRealState;
                         Model.payCertifyStatus = user.payCertifyStatus;
                         Model.isChangeRealName = user.isChangeRealName;
                         Model.alChgRealName = user.alChgRealName;
                         modBussService.getMerchantInfo(function (bankInfos) {
                             //有境内银行帐号,且境内银行帐号和跨境银行帐号 在审核中的情况，则不展示更名按钮
                             Model.isShowForBankState = !((bankInfos.bankInfoCN && (bankInfos.bankInfoCN.verifyBankState === 1 || bankInfos.bankInfoCN.updateBankState === 1)) ||
                             (bankInfos.bankInfoEN && (bankInfos.bankInfoEN.verifyBankState === 1 || bankInfos.bankInfoEN.updateBankState === 1)));
                         });

                         //实名变更增加的选项配置 end verifyType == 4 为个人银联认证用户
                         if(Model.userInfo.verifyType == 4 && Model.userInfo.isChangeRealName == 0 && !Model.userInfo.perCtf3){
                             Model.isShowPerCtf3 = false;
                         }

                         // 选择的语种
                         Model.selectedMsgLang = langService.getLangItemByLang(Model.userInfo.msgLang);
                         //是否展示needAppealAttach 申诉附件
                         getExtAttr('needAppealAttach').then(function (flag) {
                             if (flag == 1) {
                                 Model.needAppealAttach = true;
                             }
                         });
                     });
                     })

            }



            // 设置页面只读
            function setReadOnly() {
                Model.isAudting = true;
                Model.isRadioDisable = true;
                Model.graySubmit();
            }
            
            Model.toModCloudAcademy = function(){
            	$state.go('modCloudCademyinfo', {reload: true});
            };

            // 设置通知消息语种
            Model.changeMsgLang = function (selected) {
                Model.userInfo.msgLang = selected.key;
                // 获取质数
                var prime = primes.msgLangPrime;
                // 如果新值跟原值不一样，则亮化提交按钮，并计入changeNum
                (Model.userInfo.msgLang && oldUserInfo.msgLang != Model.userInfo.msgLang) ? differValue(prime, changeNum):sameValue(prime, changeNum);
            };



        }]);
});

